import { IconRegularChevronRight, theme } from '@notino/react-styleguide';

import { CdnImage } from '@components/CdnImage';
import { styled } from '@linaria/react';

export const PopupBoxWrapper = styled.button`
  border: none;
  width: 100%;
  text-align: left;
  padding: 0.75rem;
  margin-top: 0.5rem;
  background: ${theme.color.background.secondary};
  display: flex;
  align-items: center;
  gap: 0.5rem;
  cursor: pointer;

  ${theme.typography.labelRegular400}
  color: ${theme.color.text.secondary};

  &:hover {
    background: ${theme.color.background.secondaryHover};
  }
`;

export const Chevron = styled(IconRegularChevronRight)`
  color: ${theme.color.icon.tertiary};
  height: 1.25rem;
  width: 1.25rem;
  margin-left: auto;
`;

export const StyledImage = styled.img`
  height: 3rem;
  width: 3rem;
  object-fit: contain;
  mix-blend-mode: multiply;
`;

export const StyledCdnImage = styled(CdnImage)`
  height: 3rem;
  width: 3rem;
  object-fit: contain;
  mix-blend-mode: multiply;
`;

export const ImagePlaceholder = styled.div`
  height: 3rem;
  width: 3rem;
`;
